import DeferredDiscountModal from './DeferredDiscountModal'

export default DeferredDiscountModal
